/**
 * A calm full-screen loading state shown while `useAuth` resolves
 * the initial `/me` call.
 *
 * No spinner, no shimmer — just the brand mark centered with a short
 * status line. Matches the reflective-not-playful motion rule from
 * STYLE_GUIDE §1.5 and §2.6. If you find yourself wanting a
 * spinner here, don't — the call is ~50-150ms on a warm cache and
 * a brief solid frame feels better than a half-turn of a spinner.
 */

import { BrandMark } from "./BrandMark";

interface Props {
  message?: string;
}

export function LoadingShell({ message = "Loading…" }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-6 py-32">
      <BrandMark />
      <div className="font-sans text-sm text-ink-muted">{message}</div>
    </div>
  );
}
